export const ENV_CONFIG = {
  local: {
    auth_token: "auth_token",
    app_domain:null,
    // api_url: "http://localhost:3100/",
    api_url: "https://admin.universeforgood.com/",
    // api_url: "https://orbit-api.stg.sodisys.net/"
  }
};
